module.exports = __webpack_public_path__ + "img/SFA Event3.ab277aee.jpeg";